import { Flex, SimpleGrid } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import Layout from "components/Layout";
import { toaster } from "components/ui/toaster";
import constant from "constant";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";

function ScheduleAdd() {
  const [isLoading, setIsLoading] = useState(false);

  const [daysDD, setDaysDD] = useState([]);
  const [timesDD, setTimesDD] = useState([]);
  const [processDD, setProcessDD] = useState([]);
  const [repeatDD, setRepeatDD] = useState([]);

  const [process, setProcess] = useState();
  // const [invoice, setInvoice] = useState();

  const [day, setDay] = useState();
  const [hour, setHour] = useState();
  // const [task, setTask] = useState();
  // const [id, setId] = useState();
  const [schedulename, setSchedulename] = useState();
  const [repeat, setRepeat] = useState();
  const [commence, setCommence] = useState();
  const [notify, setNotify] = useState();
  const ismobile = useCheckMobileScreen();

  const navigate = useNavigate();
  const location = useLocation();
  const action = location.state?.action;
  const itemData = location.state?.data;

  const onSubmit = async () => {
    setIsLoading(true);
    const pl = {
      schedulename: schedulename || "",
      day: parseInt(day || 0),
      hour: parseInt(hour || 0),
      task: process || "",
      commence: commence ? utils.dateToDateInput(commence) : "",
      commenceseconds: commence ? utils.yyyymmddToDbSec(commence) : "",
      repeat: repeat || "",
      notify: notify || "",
    };

    let res;
    if (action === "schedule-edit") {
      pl.id = itemData?.id;
      res = await api.updateSchedule(pl);
    } else {
      res = await api.addSchedule(pl);
    }

    setIsLoading(false);
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });

    if (res?.status === 200) {
      navigate("/schedule", {});
    }
  };

  const onChangeDaysDD = (data) => {
    setDaysDD(data?.list);
    setDay(data?.item?.id);
  };

  const onChangeTimesDD = (data) => {
    setTimesDD(data?.list);
    setHour(data?.item?.value);
  };

  const onChangeProcessDD = (data) => {
    setProcessDD(data?.list);
    setProcess(data?.item?.value);
  };

  // const onChangeInvoicesDD = (data) => {
  //   setInvoicesDD(data?.list);
  //   setInvoice(data?.item?.value);
  // };

  const onChangeRepeatDD = (data) => {
    setRepeatDD(data?.list);
    setRepeat(data?.item?.value);
  };

  const getDaysDD = () => {
    let arr = JSON.parse(JSON.stringify(constant.daysDD));
    let index;
    let item;
    if (
      itemData?.day === undefined ||
      itemData?.day === null ||
      itemData?.day === ""
    ) {
    } else {
      arr = arr.map((a, idx) => {
        if (a?.id === itemData?.day) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeDaysDD({
      index,
      list: arr,
      item,
    });
  };

  const getTimesDD = () => {
    let arr = JSON.parse(JSON.stringify(constant.timesDD));
    let index;
    let item;
    if (
      itemData?.hour === undefined ||
      itemData?.hour === null ||
      itemData?.hour === ""
    ) {
    } else if (itemData?.hour) {
      arr = arr.map((a, idx) => {
        if (a?.id === itemData?.hour) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }

    onChangeTimesDD({
      index,
      list: arr,
      item,
    });
  };

  const getProcessDD = () => {
    let arr = JSON.parse(JSON.stringify(constant.processDD));
    let index;
    let item;
    if (
      itemData?.task === undefined ||
      itemData?.task === null ||
      itemData?.task === ""
    ) {
    } else if (itemData?.task?.toString) {
      arr = arr.map((a, idx) => {
        if (a?.label === itemData?.task) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }
    onChangeProcessDD({
      index,
      list: arr,
      item,
    });
  };

  const getRepeatDD = () => {
    let arr = JSON.parse(JSON.stringify(constant.repeatDD));
    let index;
    let item;
    if (
      itemData?.repeat === undefined ||
      itemData?.repeat === null ||
      itemData?.repeat === ""
    ) {
    } else if (itemData?.repeat?.toString) {
      arr = arr.map((a, idx) => {
        if (a?.label === itemData?.repeat) {
          a.selected = true;
          item = a;
          index = idx;
        }
        return a;
      });
    }
    onChangeRepeatDD({
      index,
      list: arr,
      item,
    });
  };

  useEffect(() => {
    console.log("ScheduleAdd itemData ", itemData);
    getDaysDD();
    getTimesDD();
    getProcessDD();
    getRepeatDD();

    setSchedulename(itemData?.schedulename || "");
    setCommence(itemData?.commence);

    setNotify(itemData?.notify || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Schedule${
          action === "schedule-edit"
            ? `- ${itemData?.schedulename || ""}`
            : " Add"
        }`}
        isLoading={isLoading}
      />
      <Layout>
        <Flex
          flex={1}
          // maxW={"26rem"}
          direction={"column"}
          overflow={"scroll"}
          gap={"0.6rem"}
          justifyContent={"space-between"}
        >
          <SimpleGrid
            columns={ismobile ? 1 : 2}
            // maxWidth={"25rem"}
            columnGap="1rem"
            rowGap="1rem"
          >
            <InputComp
              // <Field.Root orientation="horizontal" gap={4}>
              // <Field.Label textStyle={fs}>Task</Field.Label>
              // <Input
              label={"Task"}
              type="text"
              value={schedulename}
              onChange={setSchedulename}
              // textStyle={"md"}
            />
            {/* </Field.Root> */}
            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Day</Field.Label>
            <DropDown />
          </Field.Root> */}

            <InputComp
              label={"Day"}
              type={"dropdown"}
              items={daysDD}
              onChange={onChangeDaysDD}
            />

            <InputComp
              label={"Time"}
              type={"dropdown"}
              items={timesDD}
              onChange={onChangeTimesDD}
            />
            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Time</Field.Label>
            <Input
              type="text"
              value={hour}
              onChange={(e) => setHour(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

            <InputComp
              label={"Process"}
              type={"dropdown"}
              items={processDD}
              onChange={onChangeProcessDD}
            />

            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Process</Field.Label>
            <DropDown />
          </Field.Root> */}

            <InputComp
              label={"Start"}
              type={"date"}
              value={commence}
              onChange={setCommence}
            />
            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Start</Field.Label>
            <InputComp
              value={rundate}
              onChange={setRundate}
              type="date"
              // textStyle={"md"}
            />
          </Field.Root> */}

            <InputComp
              label={"Repeat"}
              type={"dropdown"}
              items={repeatDD}
              onChange={onChangeRepeatDD}
            />

            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Repeat</Field.Label>
            <DropDown />
          </Field.Root> */}

            <InputComp
              label={"Notification to"}
              // type={"dropdown"}
              value={notify}
              onChange={setNotify}
            />

            {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Notification to</Field.Label>
            <Textarea
              value={notify}
              onChange={(e) => setNotify(e.target.value)}
              type="text"
              textStyle={"md"}
            />
          </Field.Root> */}

            {/* <InputComp
            label={"Log"}
            // type={"dropdown"}
            value={notify}
            onChange={setNotify}
          /> */}

            {/* <Field.Root orientation="horizontal" gap={4}> */}
            {/* <Field.Label textStyle={fs}>Log</Field.Label> */}
            {/* <Text flex={1}>{message}19-4-2024: success</Text> */}
            {/* <Input
                  type="text"
                  value={calculatedtotal}
                  onChange={(e) => setCalculatedtotal(e.target.value)}
                  textStyle={"md"}
                /> */}
            {/* </Field.Root> */}
          </SimpleGrid>
        </Flex>
      </Layout>
      <Flex flexFlow={"wrap"} mt={"1rem"} gap={"1rem"} alignSelf={"end"}>
        {/* <Button w={"12rem"} variant={"outline"}>
            Delete
          </Button> */}

        {/* <Button w={"12rem"} variant={"outline"}></Button> */}

        {action === "schedule-edit" ? (
          <ButtonComp
            label="Save"
            onClick={onSubmit}
            keyname="save"
            disabled={isLoading}
          />
        ) : (
          <ButtonComp
            label="Add"
            onClick={onSubmit}
            keyname="add"
            disabled={isLoading}
          />
        )}
      </Flex>
    </Flex>
  );
}

export default ScheduleAdd;
